const fetchToken = async () => {

  const whereStartChat = localStorage.getItem('whereStartChat');
  if (whereStartChat === null || whereStartChat === 'newChat') {
    const response = await fetch(
       `${process.env.REACT_APP_API_URL}/bot/token`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    if (!response.ok) {
      throw new Error(
        `Direct Line token API call failed with status ${response.status}`
      );
    }

    const responseJson = await response.json();

    return responseJson
  } else {
    return localStorage.getItem('lastToken');
  }
}

const fetchTokenFromTeams = async (token: string) => {
  const response = await fetch(
    "/getTeamsToken?token=" + token,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json"
      }
    });

  if (!response.ok) {
    throw new Error(
      `Direct Line token API call failed with status ${response.status}`
    );
  }

  const responseJson = await response.text();

  return responseJson
}

const fetchTokenFromAAD = async (code: string) => {
  try{
    const response = await fetch(
      "/getTokenFromAAD?code=" + code,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      });
  
    if (!response.ok) {
      throw new Error(
        `Direct Line token API call failed with status ${response.status}`
      );
    }
  
    const responseJson = await response.text();
  
    return responseJson
  } catch (error) {
    console.error('Fetching token from AAD error:', error);
    localStorage.removeItem('newToken');
    throw error;
  }
}

const fetchConversationsIds = async (jwt: string) => {
  const response = await fetch(
    "/conversationsIds",
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt
      }
    });

  if (!response.ok) {
    throw new Error(
      `Direct Line token API call failed with status ${response.status}`
    );
  }

  const responseJson = await response.json();

  return responseJson;
}

const fetchConversationHistory = async (conversationId: string, jwt: string) => {
  const response = await fetch(
    "/conversationHistory/" + conversationId,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt
      }
    });

  if (!response.ok) {
    throw new Error(
      `Direct Line token API call failed with status ${response.status}`
    );
  }

  const responseJson = await response.json();

  return responseJson;
}

const fetchPromptsTotry = async (jwt: string, promptType: string) => {
  const response = await fetch(
    "/getPromptsToTry/" + promptType,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt
      }
    });

  if (!response.ok) {
    throw new Error(
      `API call failed with status ${response.status}`
    );
  }

  const responseJson = await response.json();

  return responseJson;
}

const fetchPromptsHistory = async (jwt: string) => {
  const response = await fetch(
    "/prompsHistory",
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt
      }
    });

  if (!response.ok) {
    throw new Error(
      `Direct Line token API call failed with status ${response.status}`
    );
  }

  const responseJson = await response.json();

  return responseJson;
}

export default { fetchToken, fetchTokenFromTeams, fetchTokenFromAAD, fetchConversationsIds, fetchConversationHistory, fetchPromptsTotry, fetchPromptsHistory }
